import { useEffect, useState } from 'react';
import { Col, Divider, Form, Row } from 'antd';
import { cloneDeep } from 'es-toolkit/object';

import { convertToFloat } from '@/utilz';

import { LADCovertDatesFromMomentToAPIType } from '../../../../../../utilz/PreClaimsUtils';
import Button from '../../../../../components/Buttons/Button';
import SaveCancelButton from '../../../../../components/Common/SaveCancelButton';
import PrimaryLabel from '../../../../../components/Labels/PrimaryLabel';
import { useGetClaimDetails, useSaveClaim } from '../../hooks';
import LADClaimFinancialsForm from './LADClaimFinancialsForm';

const LADClaimFinancialsTab = ({ claimKey }) => {
  const [form] = Form.useForm();
  const [editMode, setEditMode] = useState(false);
  const { data: claimDetails } = useGetClaimDetails(claimKey);
  const { mutate: saveClaim } = useSaveClaim();

  const handleSubmit = (data) => {
    if (!claimDetails) {
      return;
    }
    let payload = cloneDeep(claimDetails);
    payload = { ...payload, ...data };
    payload = LADCovertDatesFromMomentToAPIType(payload);
    saveClaim(payload, { onSuccess: () => setEditMode(false) });
  };

  const handleCancel = () => {
    form.setFieldsValue(claimDetails);
    setEditMode(false);
  };

  useEffect(() => {
    if (claimDetails) {
      form.setFieldsValue({
        ...claimDetails,
        claimAddCharge: convertToFloat(claimDetails.claimAddCharge),
        claimAdminCharge: convertToFloat(claimDetails.claimAdminCharge),
        claimCreditAmount: convertToFloat(claimDetails.claimCreditAmount),
        claimDeductibleAmount: convertToFloat(claimDetails.claimDeductibleAmount),
        claimFreightCharge: convertToFloat(claimDetails.claimFreightCharge),
        claimTaxAmount: convertToFloat(claimDetails.claimTaxAmount),
        inspectionCost: convertToFloat(claimDetails.inspectionCost),
        interestExpense: convertToFloat(claimDetails.interestExpense),
        laborCharge: convertToFloat(claimDetails.laborCharge),
        productClaimAmount: convertToFloat(claimDetails.productClaimAmount),
        repairCostAmount: convertToFloat(claimDetails.repairCostAmount),
        salvageAmount: convertToFloat(claimDetails.salvageAmount),
      });
    }
  }, [claimDetails, form]);

  return (
    <Form form={form} onFinish={handleSubmit} className="d-flex flex-direction-column h-100 overflow-hidden">
      <Row className="align-items-center pt-15 px-30" justify="space-between">
        <Col>
          <PrimaryLabel className="fw-700 f-18">Claim Financials</PrimaryLabel>
        </Col>
        <Col>
          <Row justify="space-between" gutter={16}>
            <Col>
              {!editMode ? (
                <Button onClick={() => setEditMode(true)}>Edit</Button>
              ) : (
                <SaveCancelButton editMode onCancel={handleCancel} />
              )}
            </Col>
          </Row>
        </Col>
      </Row>
      <Divider className="mt-0 my-16 ml-n16 vw-100 " />
      <div className="flex-1 custom-scroll-bar">
        <div className="px-30">
          <LADClaimFinancialsForm
            form={form}
            editMode={editMode}
            setEditMode={setEditMode}
            items={claimDetails?.claimItem || []}
            detailsData={claimDetails || {}}
          />
        </div>
      </div>
    </Form>
  );
};

export default LADClaimFinancialsTab;
